module.exports = __webpack_public_path__ + "static/media/blog-37-img1.d452b4fe.webp";